import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "react-toastify";
import TextField from "../components/Input/TextField";

const Login = () => {
  const { login, isAdmin } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await login(username, password);
    setLoading(false);

    if (success){
      toast.success(isAdmin ? "Admin Hesabına Giriş Yapıldı!" : "Giriş Başarılı");
    }
  };

  return (
    <div className="h-[89vh] flex">
      <form onSubmit={handleSubmit} className="flex flex-col gap-2 p-4  rounded-xl w-80 m-auto">
        <h1 className="mb-4 text-2xl font-semibold text-gray-300">Giriş Yap</h1>
        <TextField 
          type="text" 
          placeholder="Kullanıcı Adı" 
          value={username} 
          onChange={(e) => setUsername(e.target.value)} 
          className="border p-2 rounded"
          required
        />
        <TextField 
          type="password" 
          placeholder="Parola" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          className="border p-2 rounded"
          required
        />
        <button 
          type="submit" 
          className="bg-blue-500 text-white p-2 rounded mt-2"
          disabled={loading}
        >
          {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>
      </form>
    </div>
  );
};

export default Login;